import { ProductType, SearchMaskGroupType } from '../globalTypes';
var ProductTypeHelper = /** @class */ (function () {
    function ProductTypeHelper() {
    }
    ProductTypeHelper.mapToSearchMaskGroupType = function (productType) {
        switch (productType) {
            case ProductType.FLIGHT:
                return SearchMaskGroupType.FLIGHT;
            case ProductType.HOTEL:
                return SearchMaskGroupType.HOTEL;
            case ProductType.PACKAGE:
                return SearchMaskGroupType.PACKAGE;
            case ProductType.RAIL_PACKAGE:
                return SearchMaskGroupType.RAIL_PACKAGE;
            default:
                return SearchMaskGroupType.PACKAGE;
        }
    };
    ProductTypeHelper.mapToCoreStateGroup = function (productType) {
        switch (productType) {
            case ProductType.FLIGHT:
                return 'flight';
            case ProductType.HOTEL:
                return 'hotel';
            case ProductType.PACKAGE:
                return 'package';
            case ProductType.RAIL_PACKAGE:
                return 'railPackage';
            default:
                return 'package';
        }
    };
    ProductTypeHelper.mapSearchMaskGroupTypeToCoreStateGroup = function (searchMaskGroupType) {
        switch (searchMaskGroupType) {
            case SearchMaskGroupType.FLIGHT:
                return 'flight';
            case SearchMaskGroupType.HOTEL:
                return 'hotel';
            case SearchMaskGroupType.PACKAGE:
                return 'package';
            case SearchMaskGroupType.RAIL_PACKAGE:
                return 'railPackage';
            default:
                return 'package';
        }
    };
    ProductTypeHelper.mapSearchMaskGroupTypeToProductType = function (searchMaskGroupType) {
        switch (searchMaskGroupType) {
            case SearchMaskGroupType.FLIGHT:
                return ProductType.FLIGHT;
            case SearchMaskGroupType.HOTEL:
                return ProductType.HOTEL;
            case SearchMaskGroupType.PACKAGE:
                return ProductType.PACKAGE;
            case SearchMaskGroupType.RAIL_PACKAGE:
                return ProductType.RAIL_PACKAGE;
            default:
                return ProductType.PACKAGE;
        }
    };
    return ProductTypeHelper;
}());
export { ProductTypeHelper };
export default ProductTypeHelper;
